import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import Env from '@ridango/core/env';
import { ApplicationFacade, SessionService } from '@ridango/components';
import { ThemeFeature } from '@ridango/core/lib/enums/features.enum';
import { HelperService } from '../../../services/helper.service';
import { AllowedPathService } from '@ridango/core';
@Component({
    selector: 'gl-footer-stw',
    templateUrl: './footer-stw.component.html',
    styleUrls: ['./footer-stw.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FooterStwComponent implements OnInit {
    logoFile: string;
    logoFileContrast: string;

    themeFeature = ThemeFeature;
    assetsPath$ = this.applicationFacade.assetsPath$;

    footerSocialLinks: string[] = this.env.FOOTER.SOCIAL_LINKS;
    footerSupportActions: string[] = this.env.FOOTER.SUPPORT_ACTIONS;
    switchCorpLink: string;
    isWebPurchaseAllowed = this.pathService.isWebPurchaseAllowed();
    isLoginOrRegistrationAllowed = this.pathService.isLoginOrRegistrationAllowed();
    allowPurchaseLinksInFooter = this.env.FOOTER?.WEB_PURCHASE_LINKS;

    constructor(
        private applicationFacade: ApplicationFacade,
        public helperService: HelperService,
        @Inject('ENV') public env: Env,
        public ridangoAuth: SessionService,
        private pathService: AllowedPathService
    ) {}

    ngOnInit() {
        this.logoFile = this.env.FOOTER?.LOGO_FILE ?? 'logo.svg';
        this.logoFileContrast = this.env.FOOTER?.LOGO_FILE_CONTRAST ?? 'logo-wcag.svg';
        this.switchCorpLink = this.getSwitchLink();
    }

    getSwitchLink(): string {
        if (this.env.IS_CORPORATE) {
            return this.env.BASE_URL.replace('-corp', '');
        } else {
            return this.env.BASE_URL.replace(this.env.APP_NAME, this.env.APP_NAME + '-corp');
        }
    }
}
